import React from 'react';
import { isNullOrUndefined } from '@utils/object';
import BrandPedidosya from '@pedidosya/web-fenix/icons/BrandPedidosYa';
import Information from '@pedidosya/web-fenix/icons/Information';

function isInvalid(number) {
  return isNullOrUndefined(number) || Number.isNaN(Number(number));
}

function formatDuration(number) {
  if (isInvalid(number)) return '-';
  return `${Math.floor(number)} min`;
}

function formatDistance(number) {
  if (isInvalid(number)) return '-';
  if (number <= 999) return `${number} m`;
  return `${Number(number / 1000).toFixed(2)} km`.replace(/\./g, ',');
}

function getTag({
  isPickup,
  isLogisticsDelivery,
  isPickupFlagEnabled,
  weeklyAmount = 0,
  pickupAmount = 0,
  messages,
}) {
  if (isPickupFlagEnabled) {
    if (weeklyAmount > 0 && pickupAmount > 0 && isPickup) {
      return {
        text: {
          message: messages.pickupAndWeekly,
          value: weeklyAmount + pickupAmount,
        },
        type: 'deals',
      };
    }
    if (weeklyAmount > 0 && isPickup) {
      return {
        text: {
          message: messages.pickupAndWeekly,
          value: weeklyAmount,
        },
        type: 'deals',
      };
    }
    if (weeklyAmount > 0) {
      return {
        text: {
          message: messages.onlyWeekly,
          value: weeklyAmount,
        },
        type: 'deals',
      };
    }
    if (pickupAmount > 0 && isPickup) {
      return {
        text: {
          message: messages.onlyPickup,
          value: pickupAmount,
        },
        type: 'deals',
      };
    }
  }

  if (isLogisticsDelivery) {
    return {
      text: messages.logistics,
      type: 'brand',
      icon: <BrandPedidosya />,
    };
  }
  return {
    text: messages.delivery,
    type: 'default',
    icon: <Information />,
  };
}

export { formatDuration, formatDistance, getTag };
